module.exports = __webpack_public_path__ + "img/upload.7cc4f7c9.png";